import { Component, Input, OnInit, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MaintenanceService } from '../../../services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { ExportDataService } from '../../../../shared/services/export-data.service';
import * as _ from 'lodash';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';
import { MaintenanceTableV4Component } from '../../maintenance-table-v4/maintenance-table-v4.component';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddEditForecastRoleManagementComponent } from './add-edit-forecast-role-management/add-edit-forecast-role-management.component';

@Component({
    selector: 'app-forecast-role-management',
    templateUrl: './forecast-role-management.component.html',
    styleUrl: './forecast-role-management.component.css',
    imports: [MatFormField, MatInput, FormsModule, LoaderComponent, MaintenanceTableV4Component, AppModalComponent, AddEditForecastRoleManagementComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ForecastRoleManagementComponent implements OnInit {


  searchField: string = '';
  @Input() isForecastAdmin: boolean = true;
  @Input() segmentData: any = [];
  @ViewChild('addEditRoleManagement') addEditRoleManagement: any;
  showLoader: boolean = true;
  actionType: string = 'Add';
  editData: any = null;
  dataSourceDetails: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  TABLE_COLUMNS: any = [
    {
      key: 'Master_Segment',
      labelKey: "Master_Segment",
      label: 'Master Segment',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'User_Role',
      labelKey: "User_Role",
      label: 'User Role',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'Users',
      labelKey: "Users",
      label: 'Users',
      filter: false,
      align: 'left',
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }],
      padding: '5px 15px 5px 5px !important'
    }
  ];

  TABLE_CONFIG: any = {
    pageSize: [10, 20, 30],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    commonEdit: true,
    commonEditLabel: 'Click to Edit',
    edit:false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    TABLE_CLASS: ''
  };
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  oldDataSource: any = [];
  isResetFilter: boolean = false;
  showModal: boolean = false;
  isTableRefreshed: boolean = false;


  constructor(private maintenanceService: MaintenanceService, private toaster: ToastrService, private exportService: ExportDataService) { }

  ngOnInit(): void {
    this.initialiseData();
  }

  initialiseData() {
    if(this.isForecastAdmin){
      this.addActions();
    }
    this.getTableData();
  }

  //Add Actions column to the table
  addActions() {
    this.TABLE_COLUMNS.push({
      key: 'Actions',
      labelKey: "Actions",
      label: 'Actions',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      width: '10% !important',
      edit: false,
      validations: [{ 'required': false }],
    });
  }

  //Search based on Master Segment, User Role, MSID, Display Name and Mail
  searchDataSet() {
    const data = this.searchTableData(this.oldDataSource, this.searchField);
    this.dataSourceDetails = new MatTableDataSource(data);
  }

  //Export the table data to excel
  exportToExcel() {
    const exportData = [];
    this.oldDataSource.forEach((val) => {
      val.Users.forEach((user: any) => {
        const exports = {};
        exports['Master Segment'] = val.Master_Segment;
        exports['User Role'] = val.User_Role;
        exports['User Name'] = user.displayName;
        exports['Mail'] = user.mail;
        exports['MSID'] = user.MSID;
        exportData.push(exports);
      })
    })
    this.exportService.exportToExcel('Infra Forecast Owner Access', [exportData], ['Forecast Owner Access']);
  }

  //Open Modal to add new entry
  AddNewEntry() {
    this.showModal = true;
    this.actionType = 'Add';
    this.editData = null;
    this.openModal();
  }

  //Open the modal
  openModal() {
    this.addEditRoleManagement.show();
  }

  //Get the data for list of forecast roles
  getTableData() {
    this.isResetFilter = false;
    this.maintenanceService.getForecastRoleManagementData().subscribe((data: any) => {
      this.handleTableData(data);
    }, (error) => {
      this.handleErrors(error);
    })
  }

  //Handle the data received from the API
  handleTableData(data: any) {
    if (!data || data.length === 0) {
      this.dataSourceDetails = new MatTableDataSource([]);
      this.showLoader = false;
      return;
    }
    data.forEach((val: any) => {
      val.Users = this.sortData(val.Users, 'displayName');
    });
    this.oldDataSource = data;
    this.dataSourceDetails = new MatTableDataSource(data);
    this.showLoader = false;
  }

  //Handle the errors while fetching the data
  handleErrors(error: any) {
    console.log(error);
    this.showLoader = false;
    this.toaster.error('Error While Fetching Data', '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

  //Sort the data based on the key
  sortData(data: any[], key: string) {
    return data.sort((a, b) => {
      return a[key].localeCompare(b[key]);
    });
  }

  //Search the data based on the search text
  searchTableData(items: any[], searchText: string): any[] {
    if (!items) {
      return []
    }
    if (searchText) {
      this.isResetFilter = true;
    }else{
      this.isResetFilter = false;
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => this.filterItem(item, searchText));
  }

  filterItem(item: any, searchText: string): boolean {
    //searching based on Master Segment and User Role
    if ((item.Master_Segment?.toLowerCase() || '').includes(searchText) || (item.User_Role?.toLowerCase() || '').includes(searchText)) {
      return true;
    }
    //searching user data based on MSID, display name and mail
    return item.Users.some((user: any) => {
      return (user.MSID?.toLowerCase() || '').includes(searchText) || (user.displayName?.toLowerCase() || '').includes(searchText) || (user.mail?.toLowerCase() || '').includes(searchText);
    })
  }

  //Handle the actions based on the edit icon click
  onEditClick(data: any) {
    this.showModal = true;
    this.actionType = 'Edit';
    this.editData = _.cloneDeep(data);  
    this.openModal();
  }

  //Closing the modal
  closeModal() {
    this.addEditRoleManagement.hide();
  }

  //Refresh the table data after updation
  refreshTable(ev){
    this.closeModal();
    this.showModal = false;
    this.showLoader = true;
    this.actionType = 'Add';
    this.editData = null;
    this.maintenanceService.deleteCachedData('getForecastRoleManagementData');
    this.getTableData();
    this.isTableRefreshed = true;
  }

  clearData(){
    this.actionType = '';
    this.editData = null;
    this.showModal = false;
  }
}
